import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles, Zap, CreditCard } from 'lucide-react';

export function FinalCTASection() {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-600 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '32px 32px'
          }}
        />
      </div>
      
      {/* Floating orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-white/10 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Animated rabbit */}
        <div className="mb-8 inline-flex">
          <svg
            viewBox="0 0 48 48"
            className="w-16 h-16 animate-bounce"
            style={{ animationDuration: '2s' }}
          >
            {/* Stylized rabbit */}
            <ellipse cx="24" cy="32" rx="12" ry="10" fill="white" fillOpacity="0.9" />
            <ellipse cx="18" cy="14" rx="4" ry="10" fill="white" fillOpacity="0.9" />
            <ellipse cx="30" cy="14" rx="4" ry="10" fill="white" fillOpacity="0.9" />
            {/* Eyes */}
            <circle cx="20" cy="30" r="2" fill="#6366F1" />
            <circle cx="28" cy="30" r="2" fill="#6366F1" />
          </svg>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Prêt à accélérer
          <br />
          vos projets ?
        </h2>

        <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
          Rejoignez les équipes qui ont choisi Lapyno pour 
          organiser leur travail et garder le contrôle.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <Button
            size="lg"
            className="w-full sm:w-auto bg-white text-indigo-600 hover:bg-slate-100 shadow-xl text-lg px-8 py-6 group"
            asChild
          >
            <a href="https://app.lapyno.com/auth?mode=signup">
              Essai gratuit 14 jours
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="w-full sm:w-auto border-white/30 text-white hover:bg-white/10 text-lg px-8 py-6"
          >
            Demander une démo
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-white/70">
          <div className="flex items-center gap-2">
            <Zap className="h-4 w-4" />
            <span>Setup en 2 minutes</span>
          </div>
          <div className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            <span>Sans carte bancaire</span>
          </div>
          <div className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            <span>Annulez à tout moment</span>
          </div>
        </div>
      </div>
    </section>
  );
}
